'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resolve = function resolve(rules) {
  var self = this;
  var current = [this.platform.os.value(), this.platform.app.value()].join('|');
  var match = void 0;
  return new Promise(function (res, rej) {
    if (!rules) {
      throw new Error('method not found');
    }
    match = _underscore2.default.find(rules, function (rule) {
      return _underscore2.default.find(rule.pattern, function (version, platform) {
        return platform === current && self.version[version[0]](version[1]);
      }) || !rule.pattern;
    });
    if (!match) {
      throw new Error('app version too low');
    }
    res(_underscore2.default.bind(match.handler, self));
  });
};

exports.default = resolve;